// extracted by mini-css-extract-plugin
export default {"Card":"SurveyRecordCard_Card__APfH8","Header":"SurveyRecordCard_Header__QB+-N","Info":"SurveyRecordCard_Info__Tu94Z","Status":"SurveyRecordCard_Status__0eXHd"};